import { render, staticRenderFns } from "./SalarySlipList.vue?vue&type=template&id=72851f61&scoped=true&"
import script from "./SalarySlipList.vue?vue&type=script&lang=js&"
export * from "./SalarySlipList.vue?vue&type=script&lang=js&"
import style0 from "./SalarySlipList.vue?vue&type=style&index=0&id=72851f61&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72851f61",
  null
  
)

export default component.exports